module.exports = require("@nebula.gl/layers");